/**
 * 入札一覧・約定結果のワークフローの絞り込みに共通の値。
 *
 * 「ワークフローなし」 (= ワークフローを経由せずに作った札、 workflowId 未設定) の選択肢の値。
 * 実際の workflowId (ワークフローの業務ID) と衝突しない値として固定文字列を使う。 保存済みの
 * 絞り込み (AC-SC-031) に入っているので値を変えない。
 */
export const NO_WORKFLOW = '__no_workflow__'

/** 札の workflowId を絞り込みの値にする。 未設定・空文字は「ワークフローなし」。 */
export const workflowFilterKey = (workflowId: string | undefined): string =>
  workflowId !== undefined && workflowId !== '' ? workflowId : NO_WORKFLOW

/** 札に現れる workflowId (業務ID) の昇順。 「ワークフローなし」 は含めない (選択肢側で先頭に固定する)。 */
export const collectWorkflowIds = (
  rows: Iterable<{ workflowId?: string }>,
): string[] => {
  const ids = new Set<string>()
  for (const row of rows) {
    const key = workflowFilterKey(row.workflowId)
    if (key !== NO_WORKFLOW) ids.add(key)
  }
  return [...ids].sort()
}
